module.exports = __webpack_public_path__ + "img/xuchang1.d967f28d.png";